import React, { forwardRef } from 'react';
import cx from 'classnames';
import { useProgressBar } from '../../context';
import styles from '../../ProgressBar.module.scss';
const Bar = forwardRef(({ className, ...rest }, ref) => {
    const { max, type, value } = useProgressBar();
    const percentage = (value / max) * 100;
    return (React.createElement("div", { className: cx(styles.progressTrack, { [styles.rounded]: type === 'rounded' }, className), ref: ref, ...rest },
        React.createElement("div", { className: cx(styles.progressFill, {
                [styles.rounded]: type === 'rounded',
            }), style: { width: `${String(percentage)}%` } })));
});
export default Bar;
